import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cd0181d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirmation-content" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-exclamation-triangle p-mr-3",
    style: {"font-size":"2rem"}
  }),
  /*#__PURE__*/_createElementVNode("span", null, " Patient is already in the database, do you want to edit them? ")
], -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" You can't edit this patient, they're already registered in a different TC. Contact your registry at ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "mailto:kantasolurekisteri@veripalvelu.fi" }, " kantasolurekisteri@veripalvelu.fi ", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" This patient is still in pending, please contact the registry. ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Please fill valid personal number ")
const _hoisted_6 = { class: "p-mb-3" }
const _hoisted_7 = { class: "p-grid p-ai-start" }
const _hoisted_8 = { class: "p-col-12 p-lg-6 p-grid p-ml-2" }
const _hoisted_9 = { class: "p-col-12 p-lg-6 p-grid p-ml-2" }
const _hoisted_10 = { class: "p-grid p-ml-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-col-12 p-text-left p-text-bold" }, " Patient Status ", -1))
const _hoisted_12 = { class: "p-grid p-ai-start p-ml-2" }
const _hoisted_13 = { class: "p-mb-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " The patient has given his/her consent to the transfer his/her personal data (donor ID, tissue type, blood group, CMV status, gender and year of birth) to an international central data repository, which can be accessed via both the Stem Cell Registry and its foreign counterparts to search for suitable stem cell donors for him/her. ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"user-select":"none"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*"),
  /*#__PURE__*/_createTextVNode(" Required field ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Message = _resolveComponent("Message")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_ViewTemplate = _resolveComponent("ViewTemplate")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_ViewTemplate, { title: "Add/Edit patient" }, {
    default: _withCtx(() => [
      _createVNode(_component_Dialog, {
        header: "Edit patient",
        visible: _ctx.mode == _ctx.PatientMode.EDIT_CONFIRM,
        modal: true,
        closable: false
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: "No",
            icon: "pi pi-times",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closingEditPatDialog(false))),
            class: "p-button-rounded p-button-danger"
          }),
          _createVNode(_component_Button, {
            label: "Yes",
            icon: "pi pi-check",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closingEditPatDialog(true))),
            class: "p-button-rounded p-button-success",
            autofocus: ""
          })
        ]),
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["visible"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (alert) => {
        return (_openBlock(), _createBlock(_component_Message, {
          key: alert.id,
          severity: "warn"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(alert.msg), 1)
          ]),
          _: 2
        }, 1024))
      }), 128)),
      (_ctx.mode == _ctx.PatientMode.OTHER_TC)
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 0,
            severity: "error",
            closable: false
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _hoisted_3
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.mode == _ctx.PatientMode.DUPLICATE)
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 1,
            severity: "error",
            closable: false
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.validationMap.get('personalnumber'))
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 2,
            severity: "info"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("b", null, _toDisplayString(_ctx.idNameLabel), 1)
      ]),
      _createVNode(_component_TabView, {
        class: "p-mb-3 p-shadow-1",
        onInput: _ctx.valid
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, { header: "ID" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_Field, {
                    label: "Personal number",
                    bind: _ctx.getFixedProps(_ctx.idWidth),
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputText, _mergeProps(_ctx.getProps('personalnumber', 'p-col-4 p-mb-2 p-mr-1'), {
                        modelValue: _ctx.selected.personalnumber,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selected.personalnumber) = $event)),
                        type: "text"
                      }), null, 16, ["modelValue"]),
                      _createVNode(_component_Button, {
                        label: "Confirm",
                        class: "p-col-fixed p-mb-2 p-button-rounded p-button-success",
                        style: {"width":"75px"},
                        disabled: !_ctx.disable || _ctx.validationMap.get('personalnumber'),
                        onClick: _ctx.confirm
                      }, null, 8, ["disabled", "onClick"])
                    ]),
                    _: 1
                  }, 8, ["bind"]),
                  _createVNode(_component_Field, {
                    label: "T-number",
                    bind: _ctx.getFixedProps(_ctx.idWidth)
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('patientid1', _ctx.idclass), {
                        modelValue: _ctx.selected.patientid1,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selected.patientid1) = $event)),
                        type: "text"
                      }), null, 16, ["modelValue"]), [
                        [
                          _directive_tooltip,
                          _ctx.getTooltip('patientid1'),
                          void 0,
                          { focus: true }
                        ]
                      ])
                    ]),
                    _: 1
                  }, 8, ["bind"]),
                  _createVNode(_component_Field, {
                    label: "Last Name",
                    bind: _ctx.getFixedProps(_ctx.idWidth),
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('lastname', _ctx.idclass), {
                        modelValue: _ctx.selected.lastname,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selected.lastname) = $event)),
                        type: "text"
                      }), null, 16, ["modelValue"]), [
                        [
                          _directive_tooltip,
                          _ctx.getTooltip('lastname'),
                          void 0,
                          { focus: true }
                        ]
                      ])
                    ]),
                    _: 1
                  }, 8, ["bind"]),
                  _createVNode(_component_Field, {
                    label: "First Name",
                    bind: _ctx.getFixedProps(_ctx.idWidth),
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('firstname', _ctx.idclass), {
                        modelValue: _ctx.selected.firstname,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selected.firstname) = $event)),
                        type: "text"
                      }), null, 16, ["modelValue"]), [
                        [
                          _directive_tooltip,
                          _ctx.getTooltip('firstname'),
                          void 0,
                          { focus: true }
                        ]
                      ])
                    ]),
                    _: 1
                  }, 8, ["bind"]),
                  _createVNode(_component_Field, {
                    label: "Birth Name",
                    bind: _ctx.getFixedProps(_ctx.idWidth)
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('birthname', _ctx.idclass), {
                        modelValue: _ctx.selected.birthname,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selected.birthname) = $event)),
                        type: "text"
                      }), null, 16, ["modelValue"]), [
                        [
                          _directive_tooltip,
                          _ctx.getTooltip('birthname'),
                          void 0,
                          { focus: true }
                        ]
                      ])
                    ]),
                    _: 1
                  }, 8, ["bind"]),
                  _createVNode(_component_Field, {
                    label: "Birth Date",
                    bind: _ctx.getFixedProps(_ctx.idWidth),
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_Calendar, _mergeProps(_ctx.getProps('birthdate', _ctx.idclass), {
                        modelValue: _ctx.birthdate,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.birthdate) = $event)),
                        monthNavigator: "",
                        yearNavigator: "",
                        yearRange: _ctx.yearRange,
                        onDateSelect: _ctx.valid
                      }), null, 16, ["modelValue", "yearRange", "onDateSelect"]), [
                        [
                          _directive_tooltip,
                          _ctx.getTooltip('birthdate'),
                          void 0,
                          { focus: true }
                        ]
                      ])
                    ]),
                    _: 1
                  }, 8, ["bind"]),
                  _createVNode(_component_Field, {
                    label: "Ethnicity",
                    bind: _ctx.getFixedProps(_ctx.idWidth)
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_Dropdown, _mergeProps(_ctx.getProps('ethnicity', _ctx.idclass), {
                        modelValue: _ctx.selected.ethnicity,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selected.ethnicity) = $event)),
                        options: _ctx.Ethnicity.values,
                        optionLabel: "name",
                        optionValue: "code",
                        filter: true,
                        onChange: _ctx.valid
                      }), null, 16, ["modelValue", "options", "onChange"]), [
                        [
                          _directive_tooltip,
                          _ctx.getTooltip('ethnicity'),
                          void 0,
                          { focus: true }
                        ]
                      ])
                    ]),
                    _: 1
                  }, 8, ["bind"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Field, {
                    label: "Gender",
                    bind: _ctx.getFixedProps(_ctx.idWidth),
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_Dropdown, _mergeProps(_ctx.getProps('gender', _ctx.idclass), {
                        modelValue: _ctx.selected.gender,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selected.gender) = $event)),
                        options: _ctx.Gender.values.filter((v) => v != _ctx.Gender.UNKNOWN),
                        optionLabel: "name",
                        optionValue: "code",
                        onChange: _ctx.valid
                      }), null, 16, ["modelValue", "options", "onChange"]), [
                        [
                          _directive_tooltip,
                          _ctx.getTooltip('gender'),
                          void 0,
                          { focus: true }
                        ]
                      ])
                    ]),
                    _: 1
                  }, 8, ["bind"]),
                  _createVNode(_component_Field, {
                    label: "Weight (kg)",
                    bind: _ctx.getFixedProps(_ctx.idWidth)
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('weight', _ctx.idclass), {
                        modelValue: _ctx.selected.weight,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selected.weight) = $event)),
                        type: "text"
                      }), null, 16, ["modelValue"]), [
                        [
                          _directive_tooltip,
                          _ctx.getTooltip('weight'),
                          void 0,
                          { focus: true }
                        ]
                      ])
                    ]),
                    _: 1
                  }, 8, ["bind"]),
                  _createVNode(_component_Field, {
                    label: "Height (cm)",
                    bind: _ctx.getFixedProps(_ctx.idWidth)
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('height', _ctx.idclass), {
                        modelValue: _ctx.selected.height,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selected.height) = $event)),
                        type: "text"
                      }), null, 16, ["modelValue"]), [
                        [
                          _directive_tooltip,
                          _ctx.getTooltip('height'),
                          void 0,
                          { focus: true }
                        ]
                      ])
                    ]),
                    _: 1
                  }, 8, ["bind"]),
                  _createVNode(_component_Field, {
                    label: "ABO",
                    bind: _ctx.getFixedProps(_ctx.idWidth)
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_Dropdown, _mergeProps(_ctx.getProps('abo', _ctx.idclass), {
                        modelValue: _ctx.selected.abo,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selected.abo) = $event)),
                        options: _ctx.Abo.values,
                        optionLabel: "name",
                        optionValue: "code",
                        onChange: _ctx.valid
                      }), null, 16, ["modelValue", "options", "onChange"]), [
                        [
                          _directive_tooltip,
                          _ctx.getTooltip('abo'),
                          void 0,
                          { focus: true }
                        ]
                      ])
                    ]),
                    _: 1
                  }, 8, ["bind"]),
                  _createVNode(_component_Field, {
                    label: "Rh",
                    bind: _ctx.getFixedProps(_ctx.idWidth)
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_Dropdown, _mergeProps(_ctx.getProps('rh', _ctx.idclass), {
                        modelValue: _ctx.selected.rh,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selected.rh) = $event)),
                        options: _ctx.Rh.values,
                        optionLabel: "name",
                        optionValue: "code",
                        onChange: _ctx.valid
                      }), null, 16, ["modelValue", "options", "onChange"]), [
                        [
                          _directive_tooltip,
                          _ctx.getTooltip('rh'),
                          void 0,
                          { focus: true }
                        ]
                      ])
                    ]),
                    _: 1
                  }, 8, ["bind"])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, {
            header: "Medical",
            disabled: _ctx.disable
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_Field, {
                  label: "DG EMDIS",
                  bind: _ctx.getFixedProps(_ctx.medicalWidth),
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_Dropdown, _mergeProps(_ctx.getProps('dgemdis', _ctx.medicalclass), {
                      modelValue: _ctx.selected.dgemdis,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selected.dgemdis) = $event)),
                      options: _ctx.DgEmdis.values,
                      optionLabel: "name",
                      optionValue: "code",
                      onChange: _ctx.valid
                    }), null, 16, ["modelValue", "options", "onChange"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('dgemdis'),
                        void 0,
                        { focus: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["bind"]),
                (
            [_ctx.DgEmdis.OL.code, _ctx.DgEmdis.OM.code, _ctx.DgEmdis.OND.code].includes(
              _ctx.selected.dgemdis
            )
          )
                  ? (_openBlock(), _createBlock(_component_Field, {
                      key: 0,
                      label: "DG Text",
                      bind: _ctx.getFixedProps(_ctx.medicalWidth),
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('dgtext', _ctx.medicalclass), {
                          modelValue: _ctx.selected.dgtext,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.selected.dgtext) = $event)),
                          type: "text"
                        }), null, 16, ["modelValue"]), [
                          [
                            _directive_tooltip,
                            _ctx.getTooltip('dgtext'),
                            void 0,
                            { focus: true }
                          ]
                        ])
                      ]),
                      _: 1
                    }, 8, ["bind"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Field, {
                  label: "Date of DG",
                  bind: _ctx.getFixedProps(_ctx.medicalWidth)
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_Calendar, _mergeProps(_ctx.getProps('dateofdg', _ctx.medicalclass), {
                      modelValue: _ctx.dateofdg,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.dateofdg) = $event)),
                      monthNavigator: "",
                      yearNavigator: "",
                      yearRange: _ctx.yearRange,
                      onDateSelect: _ctx.valid
                    }), null, 16, ["modelValue", "yearRange", "onDateSelect"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('dateofdg'),
                        void 0,
                        { focus: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["bind"]),
                _createVNode(_component_Field, {
                  label: "Physician",
                  bind: _ctx.getFixedProps(_ctx.medicalWidth)
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('physician', _ctx.medicalclass), {
                      modelValue: _ctx.selected.physician,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.selected.physician) = $event)),
                      type: "text"
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('physician'),
                        void 0,
                        { focus: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["bind"]),
                _createVNode(_component_Field, {
                  label: "Disease phase",
                  bind: _ctx.getFixedProps(_ctx.medicalWidth)
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_Dropdown, _mergeProps(_ctx.getProps('diseasephase', _ctx.medicalclass), {
                      modelValue: _ctx.selected.diseasephase,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.selected.diseasephase) = $event)),
                      options: _ctx.Dispha.values,
                      optionLabel: "name",
                      optionValue: "code",
                      onChange: _ctx.valid
                    }), null, 16, ["modelValue", "options", "onChange"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('diseasephase'),
                        void 0,
                        { focus: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["bind"]),
                _createVNode(_component_Field, {
                  label: "CMV",
                  bind: _ctx.getFixedProps(_ctx.medicalWidth)
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_Dropdown, _mergeProps(_ctx.getProps('cmv', _ctx.medicalclass), {
                      modelValue: _ctx.selected.cmv,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.selected.cmv) = $event)),
                      options: _ctx.Cmv.values,
                      optionLabel: "name",
                      optionValue: "code",
                      onChange: _ctx.valid
                    }), null, 16, ["modelValue", "options", "onChange"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('cmv'),
                        void 0,
                        { focus: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["bind"]),
                _createVNode(_component_Field, {
                  label: "Search Scope",
                  bind: _ctx.getFixedProps(_ctx.medicalWidth),
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_Dropdown, _mergeProps(_ctx.getProps('searchscope', _ctx.medicalclass), {
                      modelValue: _ctx.selected.searchscope,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.selected.searchscope) = $event)),
                      options: _ctx.SearchScope.values,
                      optionLabel: "name",
                      optionValue: "code",
                      onChange: _ctx.valid
                    }), null, 16, ["modelValue", "options", "onChange"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('searchscope'),
                        void 0,
                        { focus: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["bind"]),
                _hoisted_11,
                _createVNode(_component_Field, {
                  label: "Status",
                  bind: _ctx.getFixedProps(_ctx.medicalWidth)
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_Dropdown, _mergeProps(_ctx.getProps('status', _ctx.medicalclass), {
                      modelValue: _ctx.selected.status,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.selected.status) = $event)),
                      options: _ctx.Status.values,
                      optionLabel: "name",
                      optionValue: "code",
                      onChange: _ctx.valid
                    }), null, 16, ["modelValue", "options", "onChange"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('status'),
                        void 0,
                        { focus: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["bind"]),
                _createVNode(_component_Field, {
                  label: "Death date/status chng. date",
                  bind: _ctx.getFixedProps(_ctx.medicalWidth)
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_Calendar, _mergeProps(_ctx.getProps('statusdate', _ctx.medicalclass), {
                      modelValue: _ctx.statusdate,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.statusdate) = $event)),
                      monthNavigator: "",
                      yearNavigator: "",
                      yearRange: _ctx.yearRange,
                      onDateSelect: _ctx.valid
                    }), null, 16, ["modelValue", "yearRange", "onDateSelect"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('statusdate'),
                        void 0,
                        { focus: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["bind"]),
                _createVNode(_component_Field, {
                  label: "Comment",
                  bind: _ctx.getFixedProps(_ctx.medicalWidth)
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('comment', _ctx.medicalclass), {
                      modelValue: _ctx.selected.comment,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.selected.comment) = $event)),
                      type: "text"
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('comment'),
                        void 0,
                        { focus: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["bind"])
              ])
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_TabPanel, {
            header: "DNA",
            disabled: _ctx.disable
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_Field, {
                  label: "",
                  bind: _ctx.getFixedProps(_ctx.dnaWidth),
                  class: "p-text-center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.dnaclass)
                    }, "1", 2),
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.dnaclass)
                    }, "2", 2)
                  ]),
                  _: 1
                }, 8, ["bind"]),
                _createVNode(_component_Field, {
                  label: "A",
                  bind: _ctx.getFixedProps(_ctx.dnaWidth)
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('a1', _ctx.dnaclass), {
                      modelValue: _ctx.selected.a1,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.selected.a1) = $event)),
                      type: "text",
                      onChange: _cache[25] || (_cache[25] = () => {
                _ctx.performDna('a1');
              })
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('a1'),
                        void 0,
                        { focus: true }
                      ]
                    ]),
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('a2', _ctx.dnaclass), {
                      modelValue: _ctx.selected.a2,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.selected.a2) = $event)),
                      type: "text",
                      onChange: _cache[27] || (_cache[27] = () => {
                _ctx.performDna('a2');
              })
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('a2'),
                        void 0,
                        { focus: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["bind"]),
                _createVNode(_component_Field, {
                  label: "B",
                  bind: _ctx.getFixedProps(_ctx.dnaWidth)
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('b1', _ctx.dnaclass), {
                      modelValue: _ctx.selected.b1,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.selected.b1) = $event)),
                      type: "text",
                      onChange: _cache[29] || (_cache[29] = () => {
                _ctx.performDna('b1');
              })
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('b1'),
                        void 0,
                        { focus: true }
                      ]
                    ]),
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('b2', _ctx.dnaclass), {
                      modelValue: _ctx.selected.b2,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.selected.b2) = $event)),
                      type: "text",
                      onChange: _cache[31] || (_cache[31] = () => {
                _ctx.performDna('b2');
              })
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('b2'),
                        void 0,
                        { focus: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["bind"]),
                _createVNode(_component_Field, {
                  label: "C",
                  bind: _ctx.getFixedProps(_ctx.dnaWidth)
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('c1', _ctx.dnaclass), {
                      modelValue: _ctx.selected.c1,
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.selected.c1) = $event)),
                      type: "text",
                      onChange: _cache[33] || (_cache[33] = () => {
                _ctx.performDna('c1');
              })
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('c1'),
                        void 0,
                        { focus: true }
                      ]
                    ]),
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('c2', _ctx.dnaclass), {
                      modelValue: _ctx.selected.c2,
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.selected.c2) = $event)),
                      type: "text",
                      onChange: _cache[35] || (_cache[35] = () => {
                _ctx.performDna('c2');
              })
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('c2'),
                        void 0,
                        { focus: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["bind"]),
                _createVNode(_component_Field, {
                  label: "DRB1",
                  bind: _ctx.getFixedProps(_ctx.dnaWidth)
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('drb11', _ctx.dnaclass), {
                      modelValue: _ctx.selected.drb11,
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.selected.drb11) = $event)),
                      type: "text",
                      onChange: _cache[37] || (_cache[37] = () => {
                _ctx.performDna('drb11');
              })
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('drb11'),
                        void 0,
                        { focus: true }
                      ]
                    ]),
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('drb12', _ctx.dnaclass), {
                      modelValue: _ctx.selected.drb12,
                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.selected.drb12) = $event)),
                      type: "text",
                      onChange: _cache[39] || (_cache[39] = () => {
                _ctx.performDna('drb12');
              })
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('drb12'),
                        void 0,
                        { focus: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["bind"]),
                _createVNode(_component_Field, {
                  label: "DRB3",
                  bind: _ctx.getFixedProps(_ctx.dnaWidth)
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('drb31', _ctx.dnaclass), {
                      modelValue: _ctx.selected.drb31,
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.selected.drb31) = $event)),
                      type: "text",
                      onChange: _cache[41] || (_cache[41] = () => {
                _ctx.performDna('drb31');
              })
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('drb31'),
                        void 0,
                        { focus: true }
                      ]
                    ]),
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('drb32', _ctx.dnaclass), {
                      modelValue: _ctx.selected.drb32,
                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.selected.drb32) = $event)),
                      type: "text",
                      onChange: _cache[43] || (_cache[43] = () => {
                _ctx.performDna('drb32');
              })
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('drb32'),
                        void 0,
                        { focus: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["bind"]),
                _createVNode(_component_Field, {
                  label: "DRB4",
                  bind: _ctx.getFixedProps(_ctx.dnaWidth)
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('drb41', _ctx.dnaclass), {
                      modelValue: _ctx.selected.drb41,
                      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.selected.drb41) = $event)),
                      type: "text",
                      onChange: _cache[45] || (_cache[45] = () => {
                _ctx.performDna('drb41');
              })
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('drb41'),
                        void 0,
                        { focus: true }
                      ]
                    ]),
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('drb42', _ctx.dnaclass), {
                      modelValue: _ctx.selected.drb42,
                      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.selected.drb42) = $event)),
                      type: "text",
                      onChange: _cache[47] || (_cache[47] = () => {
                _ctx.performDna('drb42');
              })
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('drb42'),
                        void 0,
                        { focus: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["bind"]),
                _createVNode(_component_Field, {
                  label: "DRB5",
                  bind: _ctx.getFixedProps(_ctx.dnaWidth)
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('drb51', _ctx.dnaclass), {
                      modelValue: _ctx.selected.drb51,
                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.selected.drb51) = $event)),
                      type: "text",
                      onChange: _cache[49] || (_cache[49] = () => {
                _ctx.performDna('drb51');
              })
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('drb51'),
                        void 0,
                        { focus: true }
                      ]
                    ]),
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('drb52', _ctx.dnaclass), {
                      modelValue: _ctx.selected.drb52,
                      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.selected.drb52) = $event)),
                      type: "text",
                      onChange: _cache[51] || (_cache[51] = () => {
                _ctx.performDna('drb52');
              })
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('drb52'),
                        void 0,
                        { focus: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["bind"]),
                _createVNode(_component_Field, {
                  label: "DQB1",
                  bind: _ctx.getFixedProps(_ctx.dnaWidth)
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('dqb11', _ctx.dnaclass), {
                      modelValue: _ctx.selected.dqb11,
                      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.selected.dqb11) = $event)),
                      type: "text",
                      onChange: _cache[53] || (_cache[53] = () => {
                _ctx.performDna('dqb11');
              })
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('dqb11'),
                        void 0,
                        { focus: true }
                      ]
                    ]),
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('dqb12', _ctx.dnaclass), {
                      modelValue: _ctx.selected.dqb12,
                      "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.selected.dqb12) = $event)),
                      type: "text",
                      onChange: _cache[55] || (_cache[55] = () => {
                _ctx.performDna('dqb12');
              })
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('dqb12'),
                        void 0,
                        { focus: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["bind"]),
                _createVNode(_component_Field, {
                  label: "DQA1",
                  bind: _ctx.getFixedProps(_ctx.dnaWidth)
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('dqa11', _ctx.dnaclass), {
                      modelValue: _ctx.selected.dqa11,
                      "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.selected.dqa11) = $event)),
                      type: "text",
                      onChange: _cache[57] || (_cache[57] = () => {
                _ctx.performDna('dqa11');
              })
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('dqa11'),
                        void 0,
                        { focus: true }
                      ]
                    ]),
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('dqa12', _ctx.dnaclass), {
                      modelValue: _ctx.selected.dqa12,
                      "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.selected.dqa12) = $event)),
                      type: "text",
                      onChange: _cache[59] || (_cache[59] = () => {
                _ctx.performDna('dqa12');
              })
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('dqa12'),
                        void 0,
                        { focus: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["bind"]),
                _createVNode(_component_Field, {
                  label: "DPB1",
                  bind: _ctx.getFixedProps(_ctx.dnaWidth)
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('dpb11', _ctx.dnaclass), {
                      modelValue: _ctx.selected.dpb11,
                      "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.selected.dpb11) = $event)),
                      type: "text",
                      onChange: _cache[61] || (_cache[61] = () => {
                _ctx.performDna('dpb11');
              })
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('dpb11'),
                        void 0,
                        { focus: true }
                      ]
                    ]),
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('dpb12', _ctx.dnaclass), {
                      modelValue: _ctx.selected.dpb12,
                      "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.selected.dpb12) = $event)),
                      type: "text",
                      onChange: _cache[63] || (_cache[63] = () => {
                _ctx.performDna('dpb12');
              })
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('dpb12'),
                        void 0,
                        { focus: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["bind"]),
                _createVNode(_component_Field, {
                  label: "DPA1",
                  bind: _ctx.getFixedProps(_ctx.dnaWidth)
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('dpa11', _ctx.dnaclass), {
                      modelValue: _ctx.selected.dpa11,
                      "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.selected.dpa11) = $event)),
                      type: "text",
                      onChange: _cache[65] || (_cache[65] = () => {
                _ctx.performDna('dpa11');
              })
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('dpa11'),
                        void 0,
                        { focus: true }
                      ]
                    ]),
                    _withDirectives(_createVNode(_component_InputText, _mergeProps(_ctx.getProps('dpa12', _ctx.dnaclass), {
                      modelValue: _ctx.selected.dpa12,
                      "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.selected.dpa12) = $event)),
                      type: "text",
                      onChange: _cache[67] || (_cache[67] = () => {
                _ctx.performDna('dpa12');
              })
                    }), null, 16, ["modelValue"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('dpa12'),
                        void 0,
                        { focus: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["bind"]),
                _createVNode(_component_Field, {
                  label: "Date of last DNA test",
                  bind: _ctx.getFixedProps(_ctx.dnaBottomWidth)
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_Calendar, _mergeProps(_ctx.getProps('datetestdna', _ctx.medicalclass), {
                      modelValue: _ctx.datetestdna,
                      "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.datetestdna) = $event)),
                      monthNavigator: "",
                      yearNavigator: "",
                      yearRange: _ctx.yearRange,
                      onDateSelect: _ctx.valid
                    }), null, 16, ["modelValue", "yearRange", "onDateSelect"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('datetestdna'),
                        void 0,
                        { focus: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["bind"]),
                _createVNode(_component_Field, {
                  label: "DNA Laboratory",
                  bind: _ctx.getFixedProps(_ctx.dnaBottomWidth)
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_Dropdown, _mergeProps(_ctx.getProps('dnalaboratory', _ctx.medicalclass), {
                      modelValue: _ctx.selected.dnalaboratory,
                      "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.selected.dnalaboratory) = $event)),
                      options: _ctx.dnaLaboratory,
                      optionLabel: "instid",
                      optionValue: "instid",
                      onChange: _ctx.valid
                    }), null, 16, ["modelValue", "options", "onChange"]), [
                      [
                        _directive_tooltip,
                        _ctx.getTooltip('dnalaboratory'),
                        void 0,
                        { focus: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["bind"])
              ])
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["onInput"]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_Checkbox, _mergeProps({ onInput: _ctx.valid }, _ctx.getProps('consent', ''), {
          modelValue: _ctx.selected.consent,
          "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.selected.consent) = $event)),
          trueValue: 1,
          falseValue: 0,
          binary: "",
          class: "p-mr-2",
          disabled: _ctx.disable || _ctx.mode == _ctx.PatientMode.EDIT
        }), null, 16, ["onInput", "modelValue", "disabled"]),
        _hoisted_14
      ]),
      _createVNode(_component_Button, {
        disabled: _ctx.disable,
        label: "Save",
        class: "p-button-rounded p-button-success p-mb-3",
        onClick: _ctx.save
      }, null, 8, ["disabled", "onClick"]),
      _hoisted_15
    ]),
    _: 1
  }))
}